import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    reference: {
      validations: []
    },
    comments: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    eventExtra3: {
      validations: []
    },
    eventExtra4: {
      validations: []
    },
    eventExtra5: {
      validations: []
    },
    eventExtra6: {
      validations: [
        { type: 'maxLength', maxLength: 50, message: '50 character maximum.' }
      ]
    },
    notes: {
      validations: []
    },
    theme: {
      validations: [
        { type: 'maxLength', maxLength: 25, message: '25 character maximum.' }
      ]
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone *',
            mapping: 'telNumber',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email',
            customClasses: ['no-label']
          },
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'How did you hear about us?',
            mapping: 'headerLabel',
            customClasses: ['subheader']
          }
        ]
      },      
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'XLarge',
            options: [
              { label: 'On Facebook', value: 'Facebook' },
              { label: 'In a web search', value: 'Web Search' },
              { label: 'I\'m a repeat guest', value: 'Repeat Guest' },
              { label: 'Referred by a friend', value: 'Friend' },
              { label: 'I saw your truck', value: 'Truck' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'reference',
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Vacation Information',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Where are you staying, if vacationing? (Name of Resort, Condo, Vacation Home, Hotel, or address)',
            mapping: 'comments',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Please Tell Us Your Event Details',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Preferred event date *',
            mapping: 'eventDate',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Total number of guests for the Boil',
            mapping: 'plannedguestcount',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Adults (12 and up)',
            mapping: 'eventExtra3',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Kids (6 to 11)',
            mapping: 'eventExtra4',
            customClasses: ['no-label']
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Littles (5 and under)',
            mapping: 'eventExtra5',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Upgrade Options',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'checkbox-list',
            size: 'XLarge',
            options: [
              { label: 'Snow Crab Legs', value: 'Snow Crab Legs' },
              { label: 'Fire Dancer / LED Hoop Performance:', value: 'Fire Dancer / LED Hoop' },
              { label: 'Late Night Option (Extra Hour of Bonfire)', value: 'Late Night Option' },
              { label: 'Corn Hole Game', value: 'Corn Hole Game' },
              { label: 'Bocce Ball Game', value: 'Bocce Ball Game' },
              { label: 'Live Local Muscian', value: 'Live Local Muscian' },
              { label: 'Mobile Cigar Lounge / Hand Rolled Cigars', value: 'Cigars' },
              { label: 'Large Cooler (with 2 Bags of Ice & Cups)', value: 'Large Cooler' },
              { label: 'Rope Ladder Game', value: 'Rope Ladder Game' },
            ],
            mapping: 'eventExtra6',
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Any additional details about your Event?',
            mapping: 'notes',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Is this a special occasion? (Birthday, Anniversary, etc.)?',
            mapping: 'theme',
            customClasses: ['no-label']
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Rollin Tide Boil Co Contact Us Form',
    formId: '539',
    clientKey: '0EA0158E-D741-4351-99DF-8A807A71DDC2',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/rollintideboilco/form_structure.js